var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MasterCard",
    transform: "translate(-121.002 -206)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149970",
    "data-name": "Rectangle 149970",
    width: 40,
    height: 40,
    transform: "translate(121.002 206)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MasterCard-dark",
    transform: "translate(121.111 214.277)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 40,
    height: 24,
    rx: 2,
    transform: "translate(-0.11 -0.279)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_333",
    "data-name": "Fill 333",
    d: "M15.536,7.768A7.768,7.768,0,1,1,7.768,0a7.768,7.768,0,0,1,7.768,7.768",
    transform: "translate(6.835 4.394)",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_334",
    "data-name": "Fill 334",
    d: "M7.594,0A7.741,7.741,0,0,0,2.379,2.011a7.918,7.918,0,0,0-.784.822H3.164a7.971,7.971,0,0,1,.592.823H1a7.8,7.8,0,0,0-.448.823H4.2a7.736,7.736,0,0,1,.329.822H.226A7.734,7.734,0,0,0,0,6.123H4.758a7.825,7.825,0,0,1,.175,1.645,7.765,7.765,0,0,1-.4,2.468H.226a7.849,7.849,0,0,0,.329.823H4.2a7.782,7.782,0,0,1-.448.823H1a7.832,7.832,0,0,0,.592.822H3.164a7.763,7.763,0,0,1-.785.823A7.768,7.768,0,1,0,7.594,0",
    transform: "translate(17.438 4.394)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_336",
    "data-name": "Fill 336",
    d: "M.77,3.331A.792.792,0,0,1,0,2.456a1.14,1.14,0,0,1,.389-.91,1.685,1.685,0,0,1,1.091-.325,2.9,2.9,0,0,1,.344.025.783.783,0,0,0,.033-.208c0-.213-.147-.292-.541-.292H1.291A2.784,2.784,0,0,0,.424.89C.432.839.536.2.541.17A3.326,3.326,0,0,1,1.55,0a1.192,1.192,0,0,1,.871.281A.893.893,0,0,1,2.657.94a4.082,4.082,0,0,1-.068.635l-.006.038c-.073.463-.225,1.427-.245,1.663h-.7l.016-.332A1.052,1.052,0,0,1,.77,3.331Zm.765-1.5c-.478,0-.72.164-.72.488a.3.3,0,0,0,.3.326c.342,0,.591-.329.606-.8A1.458,1.458,0,0,0,1.535,1.835Z",
    transform: "translate(11.065 11.164)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_337",
    "data-name": "Fill 337",
    d: "M3.382,3.94H2.538L3.022.911,1.943,3.94H1.368L1.3.928.789,3.94H0L.659,0H1.872l.073,2.206L2.685,0H4.034L3.382,3.94",
    transform: "translate(7.331 10.5)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_338",
    "data-name": "Fill 338",
    d: "M.771,3.331A.792.792,0,0,1,0,2.456a1.14,1.14,0,0,1,.39-.91,1.685,1.685,0,0,1,1.091-.325,2.906,2.906,0,0,1,.344.025.783.783,0,0,0,.033-.208c0-.213-.147-.292-.541-.292H1.291A2.8,2.8,0,0,0,.423.89C.432.84.53.24.541.171A3.3,3.3,0,0,1,1.549,0a1.192,1.192,0,0,1,.871.281A.893.893,0,0,1,2.657.94a4.078,4.078,0,0,1-.068.635l-.018.114c-.08.511-.214,1.364-.234,1.588h-.7l.016-.332A1.053,1.053,0,0,1,.771,3.331Zm.765-1.5c-.478,0-.72.164-.72.488a.3.3,0,0,0,.3.326c.342,0,.591-.329.605-.8A1.456,1.456,0,0,0,1.535,1.835Z",
    transform: "translate(24.351 11.164)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_339",
    "data-name": "Fill 339",
    d: "M1.273,3.641a1.927,1.927,0,0,1-.606.1A.617.617,0,0,1,0,3.041a7.4,7.4,0,0,1,.116-.854C.165,1.887.482,0,.482,0H1.32l-.1.485h.506l-.114.77H1.106c-.1.609-.236,1.368-.238,1.469,0,.165.088.237.289.237a.686.686,0,0,0,.227-.03l-.112.709",
    transform: "translate(15.878 10.751)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_340",
    "data-name": "Fill 340",
    d: "M1.438,3.331H1.428A1.452,1.452,0,0,1,.362,2.968,1.453,1.453,0,0,1,0,1.9,2.233,2.233,0,0,1,.417.54,1.314,1.314,0,0,1,1.467,0,1.074,1.074,0,0,1,2.6,1.159a3.411,3.411,0,0,1-.1.788H.827a.558.558,0,0,0,.11.456.8.8,0,0,0,.618.2,1.981,1.981,0,0,0,.872-.2l-.14.8A2.863,2.863,0,0,1,1.438,3.331ZM1.426.73c-.268,0-.458.2-.535.572h.926s0-.01,0-.018A.593.593,0,0,0,1.724.842.382.382,0,0,0,1.426.73Z",
    transform: "translate(17.433 11.164)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_341",
    "data-name": "Fill 341",
    d: "M.319,1.085a.935.935,0,0,0,.642.895c.341.161.395.208.395.354,0,.2-.151.29-.484.29A2.369,2.369,0,0,1,.116,2.5L0,3.237a3.93,3.93,0,0,0,.878.095c.89,0,1.3-.339,1.3-1.071a.877.877,0,0,0-.594-.893c-.353-.162-.394-.2-.394-.348,0-.173.14-.262.413-.262a4.659,4.659,0,0,1,.606.048l.12-.743A5.694,5.694,0,0,0,1.586,0C.643,0,.316.493.319,1.085",
    transform: "translate(13.589 11.164)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_342",
    "data-name": "Fill 342",
    d: "M3.795.976a1.6,1.6,0,0,1,.754.213L4.687.334A2.477,2.477,0,0,0,3.76,0,1.68,1.68,0,0,0,2.383.742c-.49-.162-.691.165-.938.492l-.219.051A1.637,1.637,0,0,0,1.253.963H.478c-.106.992-.293,2-.44,2.989L0,4.167H.844c.141-.915.218-1.5.265-1.9l.318-.176c.048-.177.2-.236.494-.229a3.59,3.59,0,0,0-.06.657c0,1.048.566,1.7,1.474,1.7a2.632,2.632,0,0,0,.746-.115l.148-.9a1.641,1.641,0,0,1-.716.2c-.49,0-.787-.362-.787-.96,0-.868.441-1.476,1.071-1.476",
    transform: "translate(20.027 10.273)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_343",
    "data-name": "Fill 343",
    d: "M2.647,4a.9.9,0,0,1-.739-.364,1.574,1.574,0,0,1-.279-.965,2.745,2.745,0,0,1,.2-1.04H1.806c-.212,0-.344.13-.526.31-.053.052-.108.107-.171.164C1.037,2.65.947,3.27.844,3.94H0l.039-.216c.048-.326.1-.658.153-.98C.3,2.085.407,1.4.478.736h.775c0,.059-.011.229-.037.479a6.846,6.846,0,0,0,.718.2A1.309,1.309,0,0,1,3,.615a1.079,1.079,0,0,1,.8.523L3.993,0h.832L4.183,3.94h-.8l.04-.3A1,1,0,0,1,2.647,4Zm.513-2.5c-.385,0-.654.443-.654,1.077,0,.419.145.632.432.632.394,0,.669-.444.669-1.08C3.607,1.715,3.448,1.492,3.16,1.492Z",
    transform: "translate(26.969 10.5)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_344",
    "data-name": "Fill 344",
    d: "M3.382,3.94H2.538L3.022.911,1.943,3.94H1.368L1.3.929.789,3.94H0L.659,0H1.872l.034,2.439L2.724,0h1.31L3.382,3.94",
    transform: "translate(7.573 10.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_345",
    "data-name": "Fill 345",
    d: "M.77,3.332A.792.792,0,0,1,0,2.456a1.139,1.139,0,0,1,.389-.91,1.686,1.686,0,0,1,1.091-.325,2.816,2.816,0,0,1,.344.025.8.8,0,0,0,.033-.209c0-.212-.147-.291-.541-.291H1.287A2.771,2.771,0,0,0,.424.89C.432.839.536.2.541.17A3.338,3.338,0,0,1,1.55,0a1.25,1.25,0,0,1,.825.239.87.87,0,0,1,.282.7,4.151,4.151,0,0,1-.068.635l-.006.035c-.073.464-.225,1.43-.246,1.666h-.7l.016-.332A1.052,1.052,0,0,1,.77,3.332Zm.765-1.5c-.478,0-.72.164-.72.487a.3.3,0,0,0,.3.327c.342,0,.591-.329.606-.8A1.38,1.38,0,0,0,1.535,1.836Z",
    transform: "translate(11.308 10.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_346",
    "data-name": "Fill 346",
    d: "M2.826.2l-.138.855A1.61,1.61,0,0,0,1.935.847c-.63,0-1.071.609-1.071,1.476,0,.6.3.959.787.959a1.632,1.632,0,0,0,.716-.2l-.148.9a2.632,2.632,0,0,1-.745.116C.566,4.094,0,3.441,0,2.393,0,.984.782,0,1.9,0a2.919,2.919,0,0,1,.927.2",
    transform: "translate(22.13 10.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_347",
    "data-name": "Fill 347",
    d: "M.771,3.332A.792.792,0,0,1,0,2.456a1.139,1.139,0,0,1,.389-.91A1.686,1.686,0,0,1,1.48,1.221a2.826,2.826,0,0,1,.344.025.8.8,0,0,0,.033-.209c0-.212-.147-.291-.541-.291H1.287A2.785,2.785,0,0,0,.423.89C.432.84.529.239.54.171A3.317,3.317,0,0,1,1.549,0a1.192,1.192,0,0,1,.871.281A.893.893,0,0,1,2.657.94a4.057,4.057,0,0,1-.068.635l-.014.09c-.076.484-.217,1.384-.237,1.611h-.7l.016-.332A1.053,1.053,0,0,1,.771,3.332Zm.764-1.5c-.478,0-.72.164-.72.487a.3.3,0,0,0,.3.327c.342,0,.591-.329.605-.8A1.381,1.381,0,0,0,1.535,1.836Z",
    transform: "translate(24.594 10.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_348",
    "data-name": "Fill 348",
    d: "M1.273,3.64a1.926,1.926,0,0,1-.606.1A.617.617,0,0,1,0,3.041a7.416,7.416,0,0,1,.116-.854C.165,1.887.482,0,.482,0H1.32l-.1.485h.43l-.115.77H1.106c-.1.61-.236,1.369-.238,1.469,0,.166.089.237.289.237a.675.675,0,0,0,.227-.03l-.112.709",
    transform: "translate(16.12 10.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_349",
    "data-name": "Fill 349",
    d: "M1.428,3.332A1.452,1.452,0,0,1,.362,2.969,1.454,1.454,0,0,1,0,1.9,2.235,2.235,0,0,1,.417.54,1.313,1.313,0,0,1,1.466,0a1.121,1.121,0,0,1,.826.314A1.179,1.179,0,0,1,2.6,1.16a3.448,3.448,0,0,1-.1.787H.827A.559.559,0,0,0,.938,2.4a.8.8,0,0,0,.618.2,1.98,1.98,0,0,0,.872-.2l-.14.8A2.9,2.9,0,0,1,1.428,3.332Zm0-2.6c-.268,0-.458.2-.536.572h.926s0-.011,0-.019A.594.594,0,0,0,1.724.841.382.382,0,0,0,1.427.73Z",
    transform: "translate(17.676 10.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_350",
    "data-name": "Fill 350",
    d: "M.319,1.085a.936.936,0,0,0,.642.895c.341.161.394.208.394.354,0,.2-.151.29-.484.29A2.376,2.376,0,0,1,.116,2.5L0,3.236a3.9,3.9,0,0,0,.877.1c.89,0,1.3-.339,1.3-1.071a.877.877,0,0,0-.595-.893c-.354-.163-.394-.2-.394-.348,0-.173.14-.262.413-.262a4.69,4.69,0,0,1,.606.049l.12-.743A5.741,5.741,0,0,0,1.586,0C.643,0,.316.493.319,1.085",
    transform: "translate(13.832 10.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_351",
    "data-name": "Fill 351",
    d: "M1.018,4a.9.9,0,0,1-.739-.364A1.574,1.574,0,0,1,0,2.666C0,1.6.628.7,1.372.7a.953.953,0,0,1,.805.437L2.364,0H3.2L2.554,3.94h-.8l.039-.3A1,1,0,0,1,1.018,4Zm.513-2.5c-.385,0-.654.443-.654,1.077,0,.419.145.631.432.631.394,0,.669-.444.669-1.08C1.979,1.715,1.82,1.491,1.532,1.491Z",
    transform: "translate(28.84 10.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_352",
    "data-name": "Fill 352",
    d: "M.478.034c-.105.992-.293,2-.44,2.989L0,3.239H.843c.3-1.959.374-2.342.848-2.294a3.145,3.145,0,0,1,.32-.929C1.658-.059,1.461.141,1.2.52A2.919,2.919,0,0,0,1.253.034H.478",
    transform: "translate(27.212 10.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_353",
    "data-name": "Fill 353",
    d: "M.479.034c-.106.992-.294,2-.44,2.989L0,3.239H.844c.3-1.959.374-2.342.847-2.294A3.165,3.165,0,0,1,2.011.015C1.658-.059,1.461.141,1.2.52a2.9,2.9,0,0,0,.05-.486H.479",
    transform: "translate(20.27 10.968)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.2612dd157725c21f1125806851c39613.svg";
export { ForwardRef as ReactComponent };